// @ts-check
import { graphql, useStaticQuery } from 'gatsby';
import type { Vv_UseExhibitorImagesQuery } from './@types/useExhibitorImages.generated';

export default function useExhibitorImages() {
  const registrations = useImagesQuery();
  return {
    getImages(companyId: string) {
      return registrations.find(
        (registration) => registration.companyId === companyId
      );
    },
  };
}

function useImagesQuery() {
  const data = useStaticQuery<Vv_UseExhibitorImagesQuery>(graphql`
    query vv_useExhibitorImages {
      bottlebooks {
        event(eventId: "620623d7b77ba18d7f4f7748", locale: de) {
          eventId
          registrations {
            nodes {
              companyId
              registrationId
              profile {
                logo {
                  publicId
                  fixed(
                    width: 120
                    height: 120
                    crop: PAD
                    background: "#FFF0"
                    quality: BEST
                  ) {
                    src
                    srcSet
                    height
                    width
                    base64
                  }
                }
                mainImage {
                  fluid(
                    maxWidth: 660
                    maxHeight: 300
                    crop: FILL
                    gravity: FACES_AUTO
                  ) {
                    src
                    srcSet
                    sizes
                    base64
                    aspectRatio
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
  return data.bottlebooks.event.registrations.nodes.map(
    ({ registrationId, companyId, profile }) => ({
      registrationId,
      companyId,
      ...profile,
    })
  );
}
